module.exports = __webpack_public_path__ + "img/logo.b7ffb70c.png";